import React, { useState, useEffect } from "react";
import "../styles/AddVendor.css";
import { useNavigate } from "react-router-dom";
import BusinessHubHeader from "../components/BusinessHubHeader";
import BackArrow from "../icons/BusinessHub/BackArrow";
import CompRegInput from "./CompRegInput";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon";
import { userService } from "../services/userService";
import companyController from "../controllers/companyController";
import { toast } from "react-toastify";
import Utils from "../utils/Utils";

function AddVendor() {
  const navigate = useNavigate();
  const jwt = userService.getUser();

  const [childDTO, setChildDTO] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [termsPop, setTermsPop] = useState(false);
  const [ischecked, setIschecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!ischecked || isSubmitting) return;

    const parsed = Utils.parseJwt(jwt);

    const companyRegisterRequest = {
      companies: [
        {
          // businessProfileID: userService.getBPID(),
          // companyID: userService.getCompID(),
          companyName: childDTO?.companyName,
          companyType: "PRIMARY",
          customObject: [
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "ID",
              countryName: "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(
                childDTO?.documents?.ownerIDPassport?.base64,
              ),
              extension: childDTO?.documents?.ownerIDPassport?.name
                ?.split(".")
                ?.pop(),
              objectName: childDTO?.documents?.ownerIDPassport?.name,
              userName: parsed?.username,
            },
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "POLICE_CLEARANCE",
              countryName: "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(
                childDTO?.documents?.policeCertificate?.base64,
              ),
              extension: childDTO?.documents?.policeCertificate?.name
                ?.split(".")
                ?.pop(),
              objectName: childDTO?.documents?.policeCertificate?.name,
              userName: parsed?.username,
            },
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "PROOF_OF_LEAGALITY",
              countryName: "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(childDTO?.documents?.legalProof?.base64),
              extension: childDTO?.documents?.legalProof?.name
                ?.split(".")
                ?.pop(),
              objectName: childDTO?.documents?.legalProof?.name,
              userName: parsed?.username,
            },
          ],
          termsAndConditionAccepted: ischecked,
          registrationNumber: childDTO?.taxNumber,
          taxNumber: childDTO?.taxNumber,
          userID: parsed?.id,
        },
      ],
    };

    try {
      setIsSubmitting(true);

      const response = await companyController.CompanyRegistration({
        companyRegisterRequest,
        Authorization: jwt,
      });

      if (Utils.isSuccessResponse(response)) {
        toast.success("Registered successfully!");
        setSubmitted(true);
      }
    } catch (err) {
      console.error("Company registration failed", err);
      toast.error("Registration failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    if (termsPop) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [termsPop]);
  return (
    <div>
      <div className="create-vendor-page-header">
        <BusinessHubHeader />
      </div>

      <div className="create-vendor-content-main-container">
        {submitted && (
          <div className="edit-role-popup-container">
            <div
              className="edit-role-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-role-popup-content">
                <div className="edit-role-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-role-successfully-added-text">
                  Verification in Progress
                </div>
                <div className="comp-reg-data-review-note">
                  We are currently reviewing your legal documents, tax number,
                  and ID. Until your information is fully verified, your access
                  will remain limited as a guest. <br />
                  <b>
                    We will notify you once your account is approved and
                    activated.
                  </b>
                </div>
                <div
                  className="edit-role-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Go to Business Overview
                </div>
              </div>
            </div>
          </div>
        )}

        {termsPop && (
          <div className="vendor-create-popup-container">
            <div
              className="vendor-create-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="vendor-create-popup-content">
                <div className="vendor-create-successfully-added-text">
                  Terms and Conditions
                </div>
                <div className="vendor-create-successfully-added-icon">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Duis autem vel eum iriure
                  dolor in hendrerit in vulputate velit esse molestie consequat,
                  vel illum dolore eu feugiat nulla facilisis at vero eros et
                  accumsan et iusto odio dignissim qui blandit praesent luptatum
                  zzril delenit augue duis dolore te feugait nulla facilisi.
                  Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
                  consectetuer adipiscing elit, sed diam nonummy nibh euismod
                  tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut
                  wisi enim ad minim veniam, quis nostrud exerci tation
                  ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                  consequat.
                </div>
                <div
                  className="vendor-create-successfully-added-action-button"
                  onClick={() => {
                    setIschecked(true);
                    setTermsPop(false);
                  }}
                >
                  Accept
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="create-vendor-content-container">
          <div className="create-vendor-data-header">
            <div className="create-vendor-header-navigation">
              <div
                className="create-vendor-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", { state: { active: "A" } })
                }
              >
                <BackArrow />
              </div>
              <div className="create-vendor-header-navigation-text">
                Back to Business Overview
              </div>
            </div>

            <div className="create-vendor-header-text">
              <div className="create-vendor-header-title">
                Add Vendor Company
              </div>
              <div className="create-vendor-header-text-note">
                Register a new vendor company with required documentation.
              </div>
            </div>
          </div>

          <div className="create-vendor-body">
            <div className="vendor-reg-window-container">
              <CompRegInput onDataChange={setChildDTO} />

              <div className="vendor-reg-info-input-body-doc-agree">
                <input
                  type="checkbox"
                  checked={ischecked}
                  onChange={(e) => setIschecked(e.target.checked)}
                  disabled={isSubmitting}
                />
                <div
                  className="vendor-reg-info-input-body-doc-agree-text"
                  onClick={() => {
                    if (!isSubmitting) setTermsPop(true);
                  }}
                >
                  I agree with the terms and conditions
                </div>
              </div>

              <div className="vendor-reg-info-input-footer">
                {!termsPop && (
                  <div
                    className="vendor-reg-submit-action-button vendor-reg-submit-button"
                    onClick={handleSubmit}
                    style={{
                      opacity: ischecked && !isSubmitting ? 1 : 0.5,
                      pointerEvents:
                        ischecked && !isSubmitting ? "auto" : "none",
                      cursor:
                        ischecked && !isSubmitting ? "pointer" : "not-allowed",
                    }}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </div>
                )}

                <div
                  className="vendor-reg-cancel-action-button vendor-reg-cancel-button"
                  onClick={() =>
                    !isSubmitting &&
                    navigate("/user-management", { state: { active: "A" } })
                  }
                  style={{
                    opacity: isSubmitting ? 0.5 : 1,
                    pointerEvents: isSubmitting ? "none" : "auto",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                  }}
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddVendor;
